import USStates from '@/models/USStates'
import map from 'lodash/map'

export default {
  namespaced: true,

  state: {
    list: [],
    listMeta: {},
    tagDetails: null
  },

  actions: {
    async getStates ({ commit }, params) {
      const query = USStates.page(params.page || 1)

      query.params({ limit: 'all' })

      const res = await query.get()

      commit('setStatesList', res.data)
      commit('setUSStatesListMeta', res.meta)
    }
  },

  mutations: {
    setStatesList (state, usStates) {
      state.list = map(usStates, usState => {
        if (usState instanceof USStates) {
          return usState
        } else {
          return new USStates(usState)
        }
      })
    },

    setUSStatesListMeta (state, meta) {
      state.listMeta = meta
    }
  }
}
